import axios from './axios';

export default {
  list() {
    return axios.get('/admin_users');
  },
};
